import { SideNavItems, SideNavSection } from '@modules/navigation/models';

export const sideNavSections: SideNavSection[] = [
    {
        text: 'MÓDULOS',
        items: ['dashboards', 'pos', 'inventario', 'bankAccounts', 'expenses', 'financialSummary', 'marketing', 'statistics'],
    },
];

export const configSection: SideNavSection = {
    text: 'CONFIGURACIÓN',
    items: ['comercio', 'help'],
};

export const sideNavItems: SideNavItems = {
    dashboards: {
        icon: 'home',
        text: 'Home',
        link: '/dashboard',
    },
    pos: {
        icon: 'shopping-cart',
        text: 'Ventas',
        submenu: [
            {
                text: 'Nueva venta',
                link: '/pos/direct-sales',
            },
            {
                text: 'Mesas',
                link: '/pos/open-sales',
            },
            {
                text: 'Canales de ventas',
                link: '/pos/sales-channels-new',
            },
            {
                text: 'Registros de ventas',
                link: '/pos/sales-registries',
            },
            {
                text: 'Caja',
                link: '/pos/cashboxes-registries',
            },
        ],
    },
    inventario: {
        icon: 'package',
        text: 'Inventario',
        submenu: [
            {
                text: 'Inventario',
                link: '/inventario/general',
            },
            {
                text: 'Recetas/Combos',
                link: '/inventario/productos-combinados',
            },
            {
                text: 'Registros',
                submenu: [
                    {
                        text: 'General',
                        link: '/inventario/registros/general',
                    },
                    {
                        text: 'Entradas',
                        link: '/inventario/registros/entradas',
                    },
                    {
                        text: 'Salidas',
                        link: '/inventario/registros/salidas',
                    },
                ],
            },
        ],
    },
    bankAccounts: {
        icon: 'credit-card',
        text: 'Cuentas',
        submenu: [
            {
                text: 'Cuentas bancarias',
                link: '/accounts/bank-accounts',
            },
            {
                text: 'Cuentas por cobrar/pagar',
                link: '/accounts/pending-accounts',
            },
            {
                text: 'Historial',
                link: '/accounts/history',
            },
        ],
    },
    expenses: {
        icon: 'file-text',
        text: 'Gastos',
        link: '/expenses',
    },
    financialSummary: {
        icon: 'book',
        text: 'Resumen Financiero',
        submenu: [
            {
                text: 'Utilidad/Perdida',
                link: '/financial-summary/utility-loss',
            },
            {
                text: 'Reportes',
                link: '/financial-summary/daily-reports',
            },
        ],
    },
    marketing: {
        icon: 'activity',
        text: 'Marketing',
        submenu: [
            {
                text: 'Clientes',
                link: '/marketing/customers',
            },
            {
                text: 'Campañas',
                link: '/marketing/campaign',
            },
        ],
    },
    statistics: {
        icon: 'bar-chart',
        text: 'Estadísticas',
        link: '/statistics',
    },
    comercio: {
        icon: 'settings',
        text: 'Configuración',
        submenu: [
            {
                text: 'Mi usuario',
                link: '/cuenta',
            },
            {
                text: 'Preferencias',
                link: '/comercio/preferencias',
            },
            {
                text: 'Usuarios asociados',
                link: '/comercio/usuarios-asociados',
            },
            {
                text: 'Cargos extra en ventas',
                link: '/comercio/staff',
            },
            {
                text: 'Códigos de descuento',
                link: '/comercio/discounts',
            },
            {
                text: 'Planes',
                link: '/comercio/plans',
            },
            {
                text: 'Cierre de caja',
                link: '/comercio/cashbox',
            },
        ],
    },
    help: {
        icon: 'help-circle',
        text: 'Centro de ayuda',
        link: 'https://intercom.help/finapartner/es',
        target: '_blank',
    },
};
